import type { SVGProps } from "react";
import * as React from "react";

const SvgAlertOctagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.86 2V1a1 1 0 0 0-.707.293zm8.28 0 .707-.707A1 1 0 0 0 16.14 1zM22 7.86h1a1 1 0 0 0-.293-.707zm0 8.28.707.707A1 1 0 0 0 23 16.14zM16.14 22v1a1 1 0 0 0 .707-.293zm-8.28 0-.707.707A1 1 0 0 0 7.86 23zM2 16.14H1a1 1 0 0 0 .293.707zm0-8.28-.707-.707A1 1 0 0 0 1 7.86zM13 8a1 1 0 1 0-2 0zm-2 4a1 1 0 1 0 2 0zm1 3a1 1 0 1 0 0 2zm.01 2a1 1 0 1 0 0-2zM7.86 3h8.28V1H7.86zm7.573-.293 5.86 5.86 1.414-1.414-5.86-5.86zM21 7.86v8.28h2V7.86zm.293 7.573-5.86 5.86 1.414 1.414 5.86-5.86zM16.14 21H7.86v2h8.28zm-7.573.293-5.86-5.86-1.414 1.414 5.86 5.86zM3 16.14V7.86H1v8.28zm-.293-7.573 5.86-5.86-1.414-1.414-5.86 5.86zM11 8v4h2V8zm1 9h.01v-2H12z"
    />
  </svg>
);
export default SvgAlertOctagon;
